import { Star, Facebook, ArrowLeft, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "@/lib/SettingsContext";
import usePageMeta from "@/lib/usePageMeta";

export default function Review() {
  usePageMeta(
    "Leave a Review · Beautify — Wadebridge, Cornwall",
    "Loved your treatment with Deborah? Leave a quick 5-star review on Google or Facebook — it takes less than a minute and means the world.",
    { noindex: true }
  );
  const { brand: BRAND } = useSettings();
  const googleUrl = (BRAND.review_google_url || "").trim();
  const facebookUrl = (BRAND.review_facebook_url || BRAND.facebook || "").trim();

  return (
    <div className="pt-32 pb-24 min-h-[80vh] bg-grain">
      <div className="mx-auto max-w-2xl px-6 text-center" data-testid="review-collector">
        <div className="flex justify-center gap-1.5 text-champagne">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={26} fill="currentColor" strokeWidth={0} />
          ))}
        </div>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl text-plum-deep">
          Loved your treatment?
        </h1>
        <p className="mt-5 text-foreground/70 leading-relaxed max-w-lg mx-auto">
          Thank you so much for visiting Beautify. If you left feeling relaxed,
          rejuvenated and pampered, a quick review would mean the world to
          Deborah — it takes less than a minute and helps other people in
          Wadebridge find their own moment of calm.
        </p>
        <div className="mt-10 flex flex-col items-center gap-4">
          {googleUrl && (
            <a
              href={googleUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-google-btn"
              className="w-full sm:w-96 inline-flex items-center justify-center gap-3 rounded-full bg-plum text-white px-8 py-4 text-base font-medium hover:bg-plum-light transition-all hover:-translate-y-0.5 shadow-sm"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#fff" d="M21.35 11.1H12v2.9h5.35c-.5 2.5-2.6 3.9-5.35 3.9a6 6 0 1 1 0-12c1.5 0 2.9.55 3.95 1.55l2.15-2.15A9 9 0 1 0 12 21c5.2 0 8.9-3.65 8.9-8.8 0-.4-.05-.75-.1-1.1Z" />
              </svg>
              Review us on Google
              <ExternalLink size={15} className="opacity-70" />
            </a>
          )}
          {facebookUrl && (
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-facebook-btn"
              className={`w-full sm:w-96 inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 text-base font-medium transition-all hover:-translate-y-0.5 shadow-sm ${
                googleUrl
                  ? "border-2 border-plum text-plum hover:bg-plum hover:text-white"
                  : "bg-plum text-white hover:bg-plum-light"
              }`}
            >
              <Facebook size={19} />
              Review us on Facebook
              <ExternalLink size={15} className="opacity-70" />
            </a>
          )}
        </div>
        <p className="mt-8 text-sm text-foreground/50">
          Reviews mention everything from massages and Dr. Hauschka facials to
          lash lifts and manicures — whatever you had, we'd love to hear about it.
        </p>
        <Link
          to="/"
          data-testid="review-back-home"
          className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-plum hover:text-plum-light transition"
        >
          <ArrowLeft size={14} /> Back to the website
        </Link>
      </div>
    </div>
  );
}
